import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';


import  { LayoutProvider } from '_context/LayoutContext';
import {
  MapProvider,
} from '_context/MapContext';


import 'resources/css/gisweb_pc.css';
import 'resources/css/ktmap.css';
import 'resources/css/mapCustom.css';



ReactDOM.render(
    <LayoutProvider>
        <MapProvider>
          <App />
        </MapProvider>
    </LayoutProvider>, 
document.getElementById('root'));